import Terms from "@/policies/eap-supplier-2025-09.md";
import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "./PolicyPage";

export const Route = createFileRoute("/policies/eap-supplier")({
  component: Page,
});

function Page() {
  return (
    <PolicyPage title="Lightbridge blue Terms of Use" updatedAt={new Date("2025-06-26T00:00:00Z")}>
      <Terms />
    </PolicyPage>
  );
}
